import { XIcon } from "@phosphor-icons/react";
import { Box, Flex, IconButton } from "@radix-ui/themes";

import { OrderTicket } from "~/v2/components/orderTicket";
import { cn } from "~/v2/utils/cn";
import type { AtdTheme } from "~/v3-poc/features/user-preferences";
import "~/v3-poc/features/workspace/widgets/orderTicket/OrderTicketWidget.css";

export interface PositionsEmbeddedTicketProps {
  theme: AtdTheme;
  symbol: string;
  quantity: number;
  onClose: () => void;
}

/**
 * The workspace order ticket, embedded in the Positions widget split pane.
 * Same chrome as the standalone ticket widget (fill + ATD dark overlay).
 */
export const PositionsEmbeddedTicket = ({
  theme,
  symbol,
  quantity,
  onClose,
}: PositionsEmbeddedTicketProps) => (
  <Flex
    direction="column"
    height="100%"
    minHeight="0"
    minWidth="0"
    className="border-[color:var(--gray-a5)] border-l"
    data-testid="positions-embedded-ticket"
  >
    <Flex align="center" justify="end" px="1" py="1" flexShrink="0">
      <IconButton
        type="button"
        size="1"
        variant="ghost"
        color="gray"
        aria-label="Close order ticket"
        onClick={onClose}
      >
        <XIcon size={14} aria-hidden />
      </IconButton>
    </Flex>
    <Box
      flexGrow="1"
      minHeight="0"
      minWidth="0"
      overflow="auto"
      className={cn("workspace-order-ticket", theme === "dark" && "dark")}
    >
      <OrderTicket
        key={`${symbol}-${quantity}`}
        symbol={symbol}
        fill
        initialQuantity={quantity}
      />
    </Box>
  </Flex>
);
